const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/ReportPage/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        noReports: 'Keine Berichte',
        cardTitle: 'Berichte',
        read: 'gelesen',
        confirmDocumentRead: 'Dokument gelesen',
        readConfirmationRequired: 'Lesebestätigung nötig',
        readConfirmationRequiredTooltip: 'Bestätigen Sie das Lesen des Dokuments',
        signed: 'unterschrieben',
        signatureRequired: 'Unterschrift nötig',
        signatureRequiredTooltip: 'Unterschreiben Sie dieses Dokument',
    },
    __RELATIVE_SOURCE_FILE__
);
